import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

import { CrudResourcePage } from '../crud/CrudResourcePage';
import { resourceConfigByName } from '../crud/resourceConfigs';
import { t } from '../i18n';
import { PendingRegisterDevicesPage } from './PendingRegisterDevicesPage';

export function LocationsPage() {
  const [tab, setTab] = useState(0);
  const locationsConfig = resourceConfigByName('locations')!;

  return (
    <Box>
      <Tabs value={tab} onChange={(_, value: number) => setTab(value)} sx={{ mb: 2.5 }}>
        <Tab label={t('locations.tabs.locations')} />
        <Tab label={t('locations.tabs.pendingRegisters')} />
      </Tabs>
      {tab === 0 ? <CrudResourcePage config={locationsConfig} /> : <PendingRegisterDevicesPage />}
    </Box>
  );
}
